import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-translate',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './translate.component.html',
  styleUrl: './translate.component.scss'
})
export class TranslateComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/translate-edit/';
  override addLink = '/dashboard/translate-create';

  clientList: Record<string, string> = {};
  clientListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('translate');
    // this.crudService.orderBy = 'createdAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Translate',
        field: 'key',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'ES',
        field: 'value_es',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'EN',
        field: 'value_en',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
    ],
    actions: [
      'edit',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
